<template>
  <div id="app" :class="vueAppClasses">
    <transition name="pages">
      <router-view :key="$route.path" @setAppClasses="setAppClasses"/>
    </transition>
  </div>
</template>

<script>
import {themeConfig, websocketServer} from '@/constants/config';
// import SocketIoService from '@/services/socketio.service.js';
import {io} from 'socket.io-client';
import store from "@/store";
import User from '@/store/modules/user';
import StudentUnitLearn from "@/store/modules/student-unit-learn";
import {createNamespacedHelpers} from "vuex";
import {createHelpers} from "vuex-map-fields";
import Swal from "sweetalert2";
import {updateReviewScore} from "@/store/modules/student-unit-learn/actions";

if (!store.state.User) store.state.registerModule(`User`, User);
if (!store.state.StudentUnitLearn) store.state.registerModule(`StudentUnitLearn`, StudentUnitLearn);

const {
  mapActions: mapUserActions,
} = createNamespacedHelpers(`User`);
const {
  mapActions: mapStudentUnitLearnActions,
} = createNamespacedHelpers(`StudentUnitLearn`);

const {
  mapFields: mapUserFields,
} = createHelpers({
  getterType: `User/getField`,
  mutationType: `User/updateField`,
});

export default {
  data() {
    return {
      vueAppClasses: [],
      socket: null,
    }
  },
  computed: {
    status() {
      return this.$store.state.status;
    },
    ...mapUserFields({
      currentUser: 'currentUser',
    }),
  },
  watch: {
    '$store.state.theme'(val) {
      this.toggleClassInBody(val)
    },
    '$vs.rtl'(val) {
      document.documentElement.setAttribute("dir", val ? "rtl" : "ltr")
    },
    status: {
      handler: function (status) {
        if (JSON.stringify(status) !== JSON.stringify(status.previous)) {
          let {title, text, color} = status.success || status.error;
          this.$vs.notify({
            time: 4000,
            title,
            text,
            color,
            icon: 'query_builder',
            position: "top-right"
          });
        }
      },
      deep: true,
      immediate: true
    },
    // temporary disable connect websocket
    /*currentUser(data) {
      if (data) {
        this.connectWebSocket();
      } else {
        this.disconnectWebSocket();
      }
    },
    */
    /*socket: {
      handler: function (data) {
        console.log('socket', data)
      },
      deep: true,
      immediate: true
    },*/
  },
  methods: {
    ...mapUserActions({
      getCurrentUser: 'getCurrentUser',
    }),
    ...mapStudentUnitLearnActions({
      updateReviewScore: 'updateReviewScore',
    }),
    toggleClassInBody(className) {
      if (className === 'dark') {
        if (document.body.className.match('theme-semi-dark')) document.body.classList.remove('theme-semi-dark');
        document.body.classList.add('theme-dark')
      } else if (className === 'semi-dark') {
        if (document.body.className.match('theme-dark')) document.body.classList.remove('theme-dark');
        document.body.classList.add('theme-semi-dark')
      } else {
        if (document.body.className.match('theme-dark')) document.body.classList.remove('theme-dark');
        if (document.body.className.match('theme-semi-dark')) document.body.classList.remove('theme-semi-dark')
      }
    },
    setAppClasses(classesStr) {
      this.vueAppClasses.push(classesStr)
    },
    handleWindowResize() {
      this.$store.commit('UPDATE_WINDOW_WIDTH', window.innerWidth);

      // Set --vh property
      document.documentElement.style.setProperty('--vh', `${window.innerHeight * 0.01}px`);
    },
    handleScroll() {
      this.$store.commit('UPDATE_WINDOW_SCROLL_Y', window.scrollY)
    },

    // WEB SOCKET EVENT FUNCTION
    connectWebSocket() {
      const socketEventListener = [
        {
          name: 'sendNotifyReview',
          method: this.showReviewDialog,
        },
        {
          name: 'sendClientLogOut',
          method: this.forceLogout,
        },
      ]
      this.setupSocketConnection(this.currentUser?.code, socketEventListener);
    },
    disconnectWebSocket() {
      if (this.socket) {
        this.socket.disconnect();
      }
    },
    setupSocketConnection(studentCode, socketEventListener) {
      if (studentCode && (!this.socket || !this.socket.connected)) {
        const token = localStorage.getItem("token");
        this.socket = io(websocketServer, {
          auth: {
            studentCode,
            authorization: token,
          },
        });

        for (let i = 0; i < socketEventListener.length; i++) {
          const event = socketEventListener[i];
          this.socket.on(event.name, async (data) => {
            await event.method(data);
          });
        }
      }
    },
    showReviewDialog(reviewPayload) {
      const payload = {
        id: reviewPayload.refeId,
      }
      const reviewTabs = reviewPayload.reviewTabs;
      const progressSteps = reviewTabs.map((e, index) => String(index + 1));
      const steps = []
      reviewTabs.forEach((e) => {
        if (e.seq !== 3) {
          const inputOptions = {};
          for (let i = 0; i < e.ratingValues.length; i++) {
            const value = e.ratingValues[i]
            const icon = e.iconMessages[i]
            const message = e.ratingMessages[i]
            inputOptions[value] = `${icon}<br>${message}`
          }
          steps.push({
            // title: e.title,
            // text: e.message,
            html: `<h4 class="mb-2 mt-2">${e.title.replace('\n', '<br>')}</h4>${e.message}`,
            input: 'radio',
            inputOptions,
            inputValidator: (value) => {
              if (!value) {
                return 'กรุณแสดงความคิดเห็นของท่าน'
              }
            },
            confirmButtonText: e.btnMessages[0]
          })
        } else {
          steps.push({
            // title: e.title,
            // text: e.message,
            html: `<h4 class="mb-2 mt-2">${e.title.replace('\n', '<br>')}</h4>${e.message}`,
            input: 'range',
            inputAttributes: {
              min: 0,
              max: e.ratingValues[0],
              step: 0.5
            },
            inputValue: 5,
            inputValidator: (value) => {
              if (!value) {
                return 'กรุณแสดงความคิดเห็นของท่าน'
              }
            },
            confirmButtonText: e.btnMessages[0]
          })
        }
      });
      Swal.mixin(
        {
          allowOutsideClick: false,
          allowEscapeKey: false,
          showCancelButton: false,
          progressSteps,
          width: 600,
        })
        .queue(steps)
        .then(async (result) => {
          if (result.value) {
            payload.reviewScore = parseInt(result.value[0])
            payload.reviewTeacherScore = parseInt(result.value[1])
            payload.reviewMaterialScore = parseInt(result.value[2])
            payload.reviewOverAllScore = parseInt(result.value[3])

            await updateReviewScore(payload);
            Swal.fire({
                title: this.$t("review-unit.completed-title"),
                text: this.$t("review-unit.completed-message"),
                icon: 'success',
                confirmButtonText: this.$t("general.close"),
              }
            )
          }
        })
    },
    forceLogout() {
      Swal.fire({
          title: this.$t("general.force-logout"),
          icon: 'warning',
          confirmButtonText: this.$t("general.close"),
        }
      ).then(() => {
        this.$store.dispatch("User/signOut", this);
      })
    },
    getUserAgent() {
      const agent = window.navigator.userAgent.toLowerCase()
      switch (true) {
        case agent.indexOf("edge") > -1:
          return "MS Edge";
        case agent.indexOf("edg/") > -1:
          return "Edge ( chromium based)";
        case agent.indexOf("opr") > -1 && !!window.opr:
          return "Opera";
        case agent.indexOf("chrome") > -1 && !!window.chrome:
          return "Chrome";
        case agent.indexOf("trident") > -1:
          return "MS IE";
        case agent.indexOf("firefox") > -1:
          return "Mozilla Firefox";
        case agent.indexOf("safari") > -1:
          return "Safari";
        default:
          return "other";
      }
    }
  },
  async mounted() {
    this.toggleClassInBody(themeConfig.theme);
    this.$store.commit('UPDATE_WINDOW_WIDTH', window.innerWidth);

    let vh = window.innerHeight * 0.01;
    // Then we set the value in the --vh custom property to the root of the document
    document.documentElement.style.setProperty('--vh', `${vh}px`);
  },
  async created() {
    // this.$store.dispatch("initializeData");

    let dir = this.$vs.rtl ? "rtl" : "ltr";
    document.documentElement.setAttribute("dir", dir);

    window.addEventListener('resize', this.handleWindowResize);
    window.addEventListener('scroll', this.handleScroll)
  },
  destroyed() {
    window.removeEventListener('resize', this.handleWindowResize);
    window.removeEventListener('scroll', this.handleScroll)

    this.disconnectWebSocket();
  },
}

</script>

<style lang="scss">
.pages-enter-active, .pages-leave-active {
  transition: opacity .5s;
}

.pages-enter, .pages-leave-to /* .fade-leave-active below version 2.1.8 */
{
  opacity: 0;
}
</style>
